import {stateUpdaterFn} from '../react/stateUpdaterFn';

export const executeOrReturnAtomState = stateUpdaterFn;
